import React, { useState } from "react";
import CommentReaction from "./CommentReaction";
import { ReactComponent as ChatIcon } from "assets/img/icons/comment.svg";
import { useMoodsContext } from "store/contexts/moodsContext";
import RepliesList from "../Reply/RepliesList";
import DeleteCommentModal from "components/DeleteCommentModal";
import { useUserContext } from "store/contexts/userContext";
import CommentMessage from "./CommentMessage";
import { useLocation } from "react-router-dom";

function CommentFooter({ post, expression, teamRole, deleteMyExpression }) {
  const { moods } = useMoodsContext();
  const { user } = useUserContext();
  const search = useLocation().search;
  const param = new URLSearchParams(search);
  const reply_id = param.get("reply_id");
  const [expressionsOpen, setExpressionsOpen] = useState(
    reply_id ? true : false
  );

  return (
    <>
      <div className="comment-footer">
        <CommentMessage post={post} expression={expression} />
        <div className="p-user-comment-footer post-footer">
          <div className="post-actions">
            <div className="left-actions">
              {(expression?.user?.id === user?.id ||
                [2, 3].includes(teamRole)) && (
                <div className="p-delete-comment fs-12">
                  <DeleteCommentModal deleteMyExpression={deleteMyExpression} />
                </div>
              )}
              <span
                className="p-comment-btn"
                onClick={() => setExpressionsOpen(!expressionsOpen)}
              >
                <ChatIcon className="mwh-16" />
              </span>
              {Boolean(moods) && Boolean(moods.length) && (
                <CommentReaction post={post} expression={expression} />
              )}
            </div>
          </div>
        </div>
      </div>
      {expressionsOpen && <RepliesList post={post} expression={expression} />}
    </>
  );
}

export default CommentFooter;
